import { Box } from "@mui/material";
import { useTranslation } from "@localization/useTranslation";
import { getLink } from "./TaskRelationsBox.hooks";
import { DotLegalHeader, DotLegalLink, DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import { EntityType } from "@common/Common.types";
import { useUrlProvider } from "../../../useUrlProvider";
import { getIcon } from "./TaskRelationsBox";
import { RelationViewModel } from "../../createTaskPane/CreateTaskPane.types.ts";
import { useRelationsListStyles } from "./RelationsList.styles";
import DotLegalList from "@common/components/dotLegalList/DotLegalList";
import DotLegalListRow from "@common/components/dotLegalList/DotLegalListRow";
import { SearchResultViewModel } from "@common/components/search/SearchResultList.types";
import AddRelationSearch from "./addRelation/AddRelationSearch";
import { useState } from "react";

export interface RelationsListProps {
    data: Array<RelationViewModel> | undefined;
    onRemoveRelation?: (relationId: string) => void;
    onRelationAdded?: (relation: SearchResultViewModel) => void;
}

function RelationsList(props: RelationsListProps) {
    const { translateString, translateEntityType } = useTranslation();
    const urlProvider = useUrlProvider();
    const styles = useRelationsListStyles();
    const [isSearchingForRelation, setIsSearchingForRelation] = useState(false);

    if (!props.data?.length && !props.onRelationAdded) {
        return null;
    }

    return (
        <DotLegalList
            addButtonText={props.onRelationAdded && translateString("addRelation")}
            onAddClick={() => setIsSearchingForRelation(true)}
            addContent={
                isSearchingForRelation && (
                    <AddRelationSearch
                        onRelationSelected={(relation) => {
                            props.onRelationAdded!(relation);
                            setIsSearchingForRelation(false);
                        }}
                        onClose={() => setIsSearchingForRelation(false)}
                    />
                )
            }
        >
            {props.data?.map((x) => (
                <DotLegalListRow key={x.entityId} onRemove={props.onRemoveRelation && (() => props.onRemoveRelation!(x.relationId))}>
                    <Box sx={styles.entity}>
                        <DotLegalTooltip text={translateEntityType(EntityType[x.entityType].toString())}>
                            <Box sx={styles.entityIcon}>{getIcon(x.entityType)}</Box>
                        </DotLegalTooltip>
                        <DotLegalHeader fontWeight={400} headerStyle={"small"} marginBottom={0}>
                            <DotLegalLink
                                linkColor={"primary"}
                                to={getLink(x.entityType, x.entityId, x.parentId, urlProvider, x.subjectEntityType, x.subjectEntityId)}
                            >
                                {x.entityName}
                            </DotLegalLink>
                        </DotLegalHeader>
                    </Box>
                </DotLegalListRow>
            ))}
        </DotLegalList>
    );
}

export default RelationsList;
